<template>
  <div>
    <HxGoodInfo :disabled="disabled" :hxSkuCode="hxSkuCode" />
  </div>
</template>
<script>
import HxGoodInfo from '../components/hx-good-info'
export default {
  name: 'ecom-base-hxGoods-detail',
  components: { HxGoodInfo },
  data() {
    return { activeName: 'skuBase', hxSkuStatus: '' }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
    hxSkuCode() {
      return this.params.hxSkuCode
    },
  },
}
</script>
